import React from "react";
import BoxLoader from "../../general/boxLoader";
import EmptyBox from "../../general/emptyBox";
import PrescriptionBillCardsBoxItem from "./prescriptionBillCardsBox_Item";

type PrescriptionFillingTableProps = {
    dataList?: any;
    isRequesting: boolean
}

const PrescriptionBillCardsBox = ({
    dataList,
    isRequesting
}: PrescriptionFillingTableProps) => {
    const _dataList = dataList && dataList.length > 0 && dataList.map((item: any, i: number) => {
        return item?.billInfo?.map((bill: any, index: number) => {
            return <PrescriptionBillCardsBoxItem item={bill} key={`${i}${index}`}/>
        })
    })
    return (
        <div>
            {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
        </div>
    )
}

export default PrescriptionBillCardsBox;
